import { useFilterOptions } from './useFiltersOptions';
import sortOptions from '@/constants/sortOptions';

export const usePickedUpFilterStore = useFilterOptions(
  'pickedupFilterStore',
  'api/transport-requests/manage/Picked-Up',
  {
    sortObj: sortOptions.dispatchedDate
  },
);
